import React from "react";
import "./BodyMobile.css";
import landingCarImage from '../../../../assets/images/landingCarImage.png';
import gift2 from "../../../../assets/images/gift2.png";

const BodyMobile = () => {
    return (
        <React.Fragment>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    marginTop: "112px",
                    width: "100%"
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            width: "40%",
                            padding: "10px",
                        }}
                    >
                        <div>
                            <img
                                src={gift2}
                                style={{
                                    width: "80px",
                                    // aspectRatio: "1.2",
                                    marginTop: "50px",
                                }}
                                alt="gift2"
                            />
                        </div>
                        <div>
                            <h2
                                className="font-face-poppins-bold exclamation-mark2"
                                style={{
                                    fontSize: "90px",
                                    lineHeight: "1",
                                }}
                            >
                                !
                            </h2>
                        </div>


                    </div>
                </div>

                {/*INICIO TEXTO*/}

                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginTop: "30px"
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            transform: "rotate(-5deg)",
                            marginLeft: "-15%"
                        }}
                    >
                        <h2
                            className="font-face-poppins-bold exclamation-mark1"
                            style={{
                                fontSize: "70px",
                                marginRight: "10px",
                            }}
                        >
                            !
                        </h2>
                        <h2
                            className="pink-rectangle-mobile font-face-encode-sans-extra-bold"
                            style={{fontSize: "35px",}}
                        >
                            Bienvenidos
                        </h2>
                    </div>

                    <div style={{transform: "rotate(5deg)", marginLeft: "15%", marginTop: "-1%"}}>
                        <h2
                            className="blue-font font-face-encode-sans-extra-bold"
                            style={{
                                fontSize: "25px",
                            }}
                        >
                            a un programa
                        </h2>
                    </div>


                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            marginTop: "-8%"
                        }}
                    >
                        <h2
                            className="pink-font font-face-encode-sans-extra-bold"
                            style={{fontSize: "25px", marginLeft: "15%"}}
                        >
                            de
                        </h2>
                        <h2
                            className="blue-rectangle-mobile font-face-encode-sans-extra-bold"
                            style={{fontSize: "30px", marginLeft: "10px", marginTop: "-3%", transform: "rotate(-4deg)"}}
                        >
                            grandes descuentos
                        </h2>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            marginTop: "-5%"
                        }}
                    >
                        <h2
                            className="pink-font font-face-encode-sans-extra-bold"
                            style={{fontSize: "25px", marginLeft: "60%"}}
                        >
                            y
                        </h2>
                        <div style={{
                            display: "flex",
                            flexDirection: "row",
                        }}>
                            <h2
                                className="light-blue-rectangle-mobile font-face-encode-sans-extra-bold"
                                style={{
                                    fontSize: "22px",
                                    marginLeft: "5px",
                                    marginTop: "-5%",
                                    transform: "rotate(5deg)"
                                }}
                            >
                                beneficios
                            </h2>
                            <h2
                                className="font-face-poppins-bold exclamation-mark2"
                                style={{
                                    fontSize: "70px",
                                    // marginLeft: "-20px"
                                }}
                            >
                                !
                            </h2>

                        </div>

                    </div>

                </div>
            </div>

        </React.Fragment>
    );
};

export default BodyMobile;
